import * as React from 'react'
import styled, { css } from '../styles/styled-components'
import { ReactComponent as HeartIcon } from '../content/svg/heart.svg'

export interface ICard {
  img: string
  href: string
  score: number
}
interface ICardProps {
  className?: string
  leader?: boolean
  place: number
  card: ICard
}

const StyledContainer = styled.div<Partial<ICardProps>>`
  cursor: pointer;
  overflow: hidden;
  border-radius: 12px;
  background: ${p => p.theme.colors.white};
  border: 1px solid ${p => p.theme.colors.gray.border};
  box-shadow: 0 2px 20px 1px rgba(176, 192, 237, 0.42);
  font-weight: 600;

  ${p => (p.leader ? 'flex-grow: 1' : '')};

  ${p => p.theme.media.sm`
    margin-bottom: 20px;
  `};

  ${p => p.theme.media.md`
    ${pr =>
      pr.leader
        ? css`
            display: flex;
            flex-flow: column nowrap;
          `
        : ''};
  `};

  a:hover {
    text-decoration: none;
  }
`
const StyledImgContainer = styled.div<Partial<ICardProps>>`
  position: relative;
  width: 100%;
  overflow: hidden;

  ${p => (p.leader ? 'flex-grow: 1' : 'padding-top: 100%')};

  ${p => p.theme.media.sm`
    padding-top: 100%;
  `};
`
const Place = styled.div<Partial<ICardProps>>`
  position: absolute;
  z-index: 1;
  width: 25px;
  height: 25px;
  top: 18px;
  left: 18px;
  line-height: 1.3;
  border-radius: 50%;
  text-align: center;
  background-color: ${p => p.theme.colors.white};

  font-size: 16px;
  border: 2px solid ${pr => pr.theme.colors.black};
  color: ${pr => pr.theme.colors.black};

  ${p => p.theme.media.mdOnly`
    width: 2.44vw;
    height: 2.44vw;
    top: 1.75vw;
    left: 1.75vw;
    font-size: 1.56vw;
  `};
`
const StyledImg = styled.img`
  position: absolute;
  left: 50%;
  top: 0;
  bottom: 0;
  height: 100%;
  max-width: none;
  transform: translateX(-50%);
`
const StyledFooter = styled.footer<Partial<ICardProps>>`
  display: flex;
  font-size: ${p => (p.leader ? '2.34vw' : '1.75vw')};
  flex-flow: row nowrap;
  padding: 6% 5%;

  border-width: 2px 0 0;
  border-style: solid;
  border-image: linear-gradient(to right, #76b1ff, #7676ff);
  border-image-slice: 1;

  ${p => p.theme.media.lg`
    font-size: ${pr => (pr.leader ? '24' : '18')}px;
  `};

  ${p => p.theme.media.sm`
    font-size: 22px;
  `};
`
const VoteButton = styled.div`
  flex-grow: 1;
  color: ${p => p.theme.colors.brand};
`
const VotesCount = styled.div<Partial<ICardProps>>`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  color: ${p => (p.leader ? p.theme.colors.accent : p.theme.colors.black)};
`
const VotesIcon = styled(HeartIcon)`
  width: 1em;
  height: 1em;
  margin-right: 0.3em;
`

export const Card: React.SFC<ICardProps> = ({ card, className, leader, place }) => (
  <StyledContainer className={className} leader={leader}>
    <StyledImgContainer leader={leader}>
      <a href={card.href} rel="noopener noreferrer" target="Model">
        <Place leader={leader}>{place}</Place>
        <StyledImg src={card.img} />
      </a>
    </StyledImgContainer>
    <a href={card.href} rel="noopener noreferrer" target="Model">
      <StyledFooter leader={leader}>
        <VoteButton>VOTE</VoteButton>
        <VotesCount leader={leader}>
          <VotesIcon />
          {card.score}
        </VotesCount>
      </StyledFooter>
    </a>
  </StyledContainer>
)



// WEBPACK FOOTER //
// ./src/components/Card.tsx